import "./RoofReplacement.module.css";
import Header from "@/reusable_sections/Header";
import ProductsHero from "./sections/ProductsHero";
import ServiceDetailsUrethaneReplacement from "./sections/ServiceDetailsUrethaneReplacement";
import Footer from "@/reusable_sections/Footer";
export default function RoofReplacementPage() {
  return <div>
      <Header />
      <ProductsHero />
      <ServiceDetailsUrethaneReplacement />
      <Footer />
    </div>;
}